export default __webpack_public_path__ + "static/media/IMG_20210706_175710-ad.28b850fe.png";